import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const TechnicianApi = createApi({
	reducerPath: "Technician",
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_BACKEND_URL}/technicians`,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			headers.set("Accept", "application/json");
			return headers;
		},
	}),

	endpoints: (builder) => ({
		registerTechnician: builder.mutation({
			query: (formData) => ({
				url: "/register",
				method: "POST",
				body: formData,
			}),
		}),
		getAllTechnician: builder.query({
			query: ({
				page: currentpage,
				pageSize: limit,
				sortBy,
				sortOrder,
				search,
			}) =>
				`?page=${currentpage ? currentpage : "1"}&limit=${
					limit ? limit : "10000"
				}${sortBy ? `&sortBy=${sortBy}` : ""}${
					sortOrder ? `&sortOrder=${sortOrder}` : ""
				}${search ? `&search=${search}` : ""}`,
		}),
		getSingleTechnician: builder.query({
			query: (id) => `/${id}`,
		}),
		deleteTechnician: builder.mutation({
			query: (id) => ({
				url: `/${id}`,
				method: "DELETE",
			}),
		}),
		editTechnician: builder.mutation({
			query: ({ id, formData }) => ({
				url: `/${id}`,
				method: "PUT",
				body: formData,
			}),
		}),
		deleteAttachment: builder.mutation({
			query: ({ id, fileType, filePath }) => ({
				url: `/${id}/files`,
				method: "DELETE",
				body: {
					type: fileType,
					filePath: filePath,
				},
			}),
		}),
		// In your TechnicianApi endpoints
		getAvailableDevices: builder.query({
			query: (params = {}) => {
				const queryParams = new URLSearchParams();

				if (params.hardware_types) {
					queryParams.append("hardware_types", params.hardware_types);
				}
				if (params.search) {
					queryParams.append("search", params.search);
				}
				if (params.page) {
					queryParams.append("page", params.page);
				}
				if (params.limit) {
					queryParams.append("limit", params.limit);
				}
				if (params.sort_by) {
					queryParams.append("sort_by", params.sort_by);
				}
				if (params.sort_order) {
					queryParams.append("sort_order", params.sort_order);
				}

				return {
					url: `/devices/available?${queryParams.toString()}`,
					method: "GET",
				};
			},
		}),
		getAllTechnicianFromUsers: builder.query({
			query: ({
				page: currentpage,
				pageSize: limit,
				sortBy,
				sortOrder,
				search,
			}) =>
				`/field-workers?page=${currentpage ? currentpage : "1"}&limit=${
					limit ? limit : "10000"
				}${sortBy ? `&sortBy=${sortBy}` : ""}${
					sortOrder ? `&sortOrder=${sortOrder}` : ""
				}${search ? `&search=${search}` : ""}`,
		}),
		getTechnicianUnderUser: builder.query({
			query: ({ userId }) => `/field-workers?userId=${userId}`,
		}),
	}),
});

export const {
	useRegisterTechnicianMutation,
	useGetAllTechnicianQuery,
	useGetSingleTechnicianQuery,
	useDeleteTechnicianMutation,
	useEditTechnicianMutation,
	useDeleteAttachmentMutation,
	useGetAvailableDevicesQuery,
	useGetAllTechnicianFromUsersQuery,
	useGetTechnicianUnderUserQuery,
} = TechnicianApi;
